export enum UserType {
  User = 0,
  Patient = 1,
  Doctor = 2,
  Admin = 3,
}
export const RoleMap = {
  owner: 'Owner',
  manager: 'Manager',
  member: 'Member',
};
export enum UserRole {
  Owner = 0,
  Manager = 1,
  Member = 2,
}
export const UserGender = {
  Male: '1',
  Female: '2',
  Other: '3',
};
export const userTypeOptions = [
  { label: 'Admin', value: UserType.Admin },
  { label: 'Doctor', value: UserType.Doctor },
  { label: 'Patient', value: UserType.Patient },
  { label: 'User', value: UserType.User },
];
export const userStatusOptions = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
];

export const statusOptions = [
  { label: 'Accepted', value: 'accepted' },
  { label: 'Pending', value: 'pending' },
  { label: 'Rejected', value: 'rejected' },
  { label: 'Cancelled', value: 'cancelled' },
  { label: 'Expired', value: 'expired' },
];

export const organizationStatusOptions = [
  { label: 'Active', value: 'active' },
  { label: 'Pending', value: 'pending' },
  { label: 'Suspended', value: 'suspended' },
];
export const roleOptions = [
  { label: 'Owner', value:'owner' },
  { label: 'Manager', value:'manager' },
  { label: 'Member', value:'member' },
];

export const genderOptions = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
  { label: 'Other', value: 'other' },
];

export const genderEnumOptions = [
  { label: 'Male', value: UserGender.Male },
  { label: 'Female', value: UserGender.Female },
  { label: 'Other', value: UserGender.Other },
];

export const statusMap: Record<string, { label: string; className: string }> = {
  active: {
    label: 'Active',
    className: 'bg-emerald-500/15 text-emerald-700 border border-emerald-500/20 hover:bg-emerald-500/20 font-medium',
  },
  inactive: {
    label: 'Inactive',
    className: 'bg-rose-500/15 text-rose-700 border border-rose-500/20 hover:bg-rose-500/20 font-medium',
  },
  suspended: {
    label: 'Suspended',
    className: 'bg-rose-500/15 text-rose-700 border border-rose-500/20 hover:bg-rose-500/20 font-medium',
  },
  pending: {
    label: 'Pending',
    className: 'bg-amber-500/15 text-amber-700 border border-amber-500/20 hover:bg-amber-500/20 font-medium',
  },
  accepted: {
    label: 'Accepted',
    className: 'bg-green-500/15 text-green-700 border border-green-500/20 hover:bg-green-500/20 font-medium',
  },
  rejected: {
    label: 'Rejected',
    className: 'bg-red-500/15 text-red-700 border border-red-500/20 hover:bg-red-500/20 font-medium',
  },
  cancelled: {
    label: 'Cancelled',
    className: 'bg-gray-500/15 text-gray-700 border border-gray-500/20 hover:bg-gray-500/20 font-medium',
  },
  expired: {
    label: 'Expired',
    className: 'bg-gray-500/15 text-gray-700 border border-gray-500/20 hover:bg-gray-500/20 font-medium',
  },
};

export enum TrackType {
  Tone = '1',
  Music = '0',
}

export const trackTypeOptions = [
  { label: 'Tone', value: TrackType.Tone },
  { label: 'Music', value: TrackType.Music },
];

export enum SessionStatus {
  Pending = 0,
  Completed = 1,
  Missed = 2,
}

export const sessionStatusOptions = [
  { label: 'Pending', value: SessionStatus.Pending },
  { label: 'Completed', value: SessionStatus.Completed },
  { label: 'Missed', value: SessionStatus.Missed },
];

export const DEFAULT_PER_PAGE = '10';

export const currencies = [
  { value: 'USD', label: 'USD ($) - US Dollar' },
  { value: 'EUR', label: 'EUR (€) - Euro' },
  { value: 'GBP', label: 'GBP (£) - British Pound' },
  { value: 'JPY', label: 'JPY (¥) - Japanese Yen' },
  { value: 'CAD', label: 'CAD (C$) - Canadian Dollar' },
  { value: 'AUD', label: 'AUD (A$) - Australian Dollar' },
  { value: 'CHF', label: 'CHF (Fr) - Swiss Franc' },
  { value: 'CNY', label: 'CNY (¥) - Chinese Yuan' },
  { value: 'INR', label: 'INR (₹) - Indian Rupee' },
  { value: 'BRL', label: 'BRL (R$) - Brazilian Real' },
  { value: 'MXN', label: 'MXN ($) - Mexican Peso' },
  { value: 'SGD', label: 'SGD (S$) - Singapore Dollar' },
  { value: 'NZD', label: 'NZD (NZ$) - New Zealand Dollar' },
  { value: 'HKD', label: 'HKD (HK$) - Hong Kong Dollar' },
  { value: 'SEK', label: 'SEK (kr) - Swedish Krona' },
  { value: 'NOK', label: 'NOK (kr) - Norwegian Krone' },
  { value: 'DKK', label: 'DKK (kr) - Danish Krone' },
  { value: 'ZAR', label: 'ZAR (R) - South African Rand' },
  { value: 'RUB', label: 'RUB (₽) - Russian Ruble' },
  { value: 'TRY', label: 'TRY (₺) - Turkish Lira' },
];

export const defaultPagination = {
  data: [],
  meta: {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 0,
    from: 0,
    to: 0,
    path: '',
    links: [
      {
        url: null,
        label: '1',
        active: true,
      },
    ],
    year_counts: [],
  },
  links: {
    first: '',
    last: '',
    prev: null,
    next: null,
  },
};

export const subscriptionTypeOptions = [
  { label: 'Trial', value: 'trial' },
  { label: 'Stripe', value: 'stripe' },
  { label: 'Legacy', value: 'legacy' },
  { label: 'Apple', value: 'apple' },
  { label: 'Google Play', value: 'google_play' },
  { label: 'No Subscription', value: 'none' },
];
export const subscriptionStatusOptions = [
  { label: 'Active', value: 'active' },
  { label: 'On Grace Period', value: 'on_grace_period' },
  { label: 'Expired', value: 'expired' },
  { label: 'Canceled', value: 'canceled' },
  { label: 'None', value: 'none' },
];
export const expirationTimeframeOptions = [
  { label: 'Expiring today', value: 'expiring_today' },
  { label: 'Expiring in 7 days', value: 'expiring_7_days' },
  { label: 'Expiring in 30 days', value: 'expiring_30_days' },
  { label: 'Expiring in 90 days', value: 'expiring_90_days' },
  { label: 'Already expired', value: 'expired' },
];
